import React from 'react';

const FormContainer = ({ children }) => {
  return (
    <div className="container mx-auto px-4">
      <div className="flex justify-center">
        <div className="w-full md:w-2/3 lg:w-1/2 xl:w-2/5 bg-white p-6 rounded-lg shadow-md">
          {children}
        </div>
      </div>
    </div>
  );
};

export default FormContainer;
